import { Pipe, PipeTransform } from '@angular/core';
import { Secuencia } from '../../../common/ivr';
import * as _ from 'lodash';

@Pipe({name: 'contexto'})
export class FiltroPorContextoPipe implements PipeTransform {

    transform(value: Secuencia[], tipo: string) {
        
        if (value !== undefined) {
            try {
                value = _.filter(value, ['contexto', tipo]);
            } catch(e){}
        }
        return value;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/ivr/contexto.pipe.ts